import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
  listBlogs,
  createBlog,
  updateBlog,
  deleteBlog,
  getBlogById,
} from "@/services/blog";

@Module({
  namespaced: true,
})
export default class Blog extends VuexModule {
  // state
  blogList = [];
  blogData = {};

  @Action
  public async createBlog(payload) {
    try {
      const data = await createBlog(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async updateBlog(payload) {
    try {
      const data = await updateBlog(payload.id, payload.data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchBlogsList() {
    try {
      const data = await listBlogs();
      this.context.commit("setBlogList", data.response || data.data || []);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchBlogById(id) {
    try {
      const data = await getBlogById(id);
      this.context.commit("setBlogData", data.response || data.data || {});
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async deleteBlog(id) {
    try {
      const data = await deleteBlog(id);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async sendBlogData(payload) {
    try {
      this.context.commit("setBlogData", payload);
      return payload;
    } catch (error) {
      throw error;
    }
  }

  // mutations
  @Mutation
  public setBlogList(data: any) {
    this.blogList = data;
  }

  @Mutation
  public setBlogData(data: any) {
    this.blogData = data;
  }

  // getters
  get GetBlogList() {
    return this.blogList;
  }

  get GetBlogData() {
    return this.blogData;
  }
}

